module.exports = __webpack_public_path__ + "static/media/carregar_comprovativo.58b8d49b.svg";